<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',minHeight: myheight + 'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>{{ myDciorderupTitle }}</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="./images/ty_close.png" alt='版权登记'/>
            </div>
			<div class="content">
				<div class="item">
					<div class="lable">填写信息</div>
					<MyUploadHw
						style="margin: 0 0 0 30px;"
						v-show="myDciOrderList.length == 0 ?
                                         true :
                                         myDciOrderList[0].status ?
                                         myDciOrderList[0].status == 'uploading' ?
                                         false :
                                         true :
                                         true "
						:oldShowList="myDciOrderList"
						:fileMultiue="false"
						:accept="workType_fileAccept"
						styleType="btn"
						:styleTypeBg="'bg'"
						@listentochildevent="showmessagefromchild"/>

					<div class="upload_progress_one" v-if="myDciOrderList.length == 0 ?
                                         false :
                                         myDciOrderList[0].status ?
                                         myDciOrderList[0].status == 'uploading' ?
                                         true :
                                         false :
                                         false ">
						上传中 {{ myDciOrderList[0].uploadProgress }}%

						<div :style="{width:myDciOrderList[0].uploadProgress + '%'}"
							 class="upload_progress_one_shadow"></div>
					</div>

					<Tooltip v-if="declare_upload_success" max-width="200"  placement="top" :content="declare_file_name">
						<span class="declare_upload_success_name">{{declare_file_name}}</span>
					</Tooltip>
					<a class="downText" :href="myDciorderupDownloadUrl" target="_blank">下载{{ myDciorderupTitle }}模板</a>
				</div>
<!--				<div class="imglist" v-show="myDciOrderList.length > 0">-->
<!--					<div v-for="(item,index) in myDciOrderList" :key="index" class="show_Picture">-->
<!--					    <div class="showSc">-->
<!--					        <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url || defaultImg"/>-->
<!--					        <span class="showDelete">-->
<!--								<img @click.stop="deleteList(item)" class="showshanchu"  src="./images/shanchu.png"/>-->
<!--							</span>-->
<!--					    </div>-->
<!--					    <div>{{item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''}}</div>-->
<!--					</div>-->
<!--				</div>-->
				<div class="tishi">
					<div class="title">温馨提示</div>
					<div class="text">
						<p>
							1、请下载{{ myDciorderupTitle }}模板，填写完成后上传即可<br>
							2、请不要在此处提交与当前作品不相关的内容。<br>
							3、该服务需要一定周期，请耐心等待<br>
						</p>
					</div>
				</div>

				<div v-if="!isActivity">
					<Row style="height: auto;" class-name="row_item_1">
						<Col class="col_label"><p>支付方式：</p></Col>
						<Col class="col_value top20">
							<component :is="PayWay" @onselected="handlePayWaySelect" :type="myDciorderupPay" :isRenew="false"></component>
						</Col>
					</Row>
				</div>

				<button class="upBtn" :disabled="isDisabled" @click="_saveMyDciOrderUp">提交</button>
			</div>
        </div>
    </div>
</template>

<script>
import { saveMyDciOrder } from "@/api/staticPage.js";
import MyUploadHw from '@/views/main-components/my-upload-hw';
import PayWay from '@/views/main-components/pay-way';
import Cookies from "js-cookie";
import '@/plugins/element.js';
import util from '@/libs/util'
const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
import _ from 'lodash';
    export default {
        name:'recharge',
        props:{
            mywidth:{
                type:String,
                default:'700'
            },
            myheight:{
                type:String,
                default:'575'
            },
            myTitleheight:{
                type:String,
                default:'50'
            },
            tishihide:{
                type:Boolean,
                default:true
            },
			dataItem: {
				type: Object,
				default: {}
			},
			myDciorderupTitle:{
				type: String,
				default: ''
			},
			myDciorderupDownloadUrl:{
				type: String,
				default: ''
			},
			myDciorderupPay:{
				type: String,
				default: ''
			},
			isActivity:{
            	type:Boolean,
				default:false
			}
        },
        data(){
            return{
				isDisabled: false,
				myDciOrderList: [],
				workType_fileAccept: "",
				maxNumber: 1,
				defaultImg: require('./images/text_icon.png'),
				payWay: '',
				itemData: {},
				declare_upload_success:false,
				declare_file_name:""
            }
        },
		components:{
			MyUploadHw,
			PayWay
		},
		watch:{
			"$store.state.app.showPayWay":function(){
				if(this.$store.state.app.showPayWay){
					this.userInfo = JSON.parse(Cookies.get("userInfo")),
					this.flagId = '',
					this.PayWay = 'PayWay'
				}
			}
		},
		created () {
			this.isLogin = Cookies.get("userInfo")? true : false;
			this.$store.state.app.showPayWay =Cookies.get("userInfo") && Cookies.get("userInfo") != ''? true : false
			this.PayWay = this.$store.state.app.showPayWay? 'PayWay':''
		},
        methods:{
			handlePayWaySelect(e) {
			    console.log(e);
			    this.payWay = e;
			},
			parentHandleclick(flag) {
				let _this = this
				console.log(_this.itemData);
				_this.myDciOrderList.splice(_this.myDciOrderList.indexOf(_this.itemData), 1);
				if(flag && flag == 'success'){
					_this.$emit('fatherModal',flag);

				}else{
					_this.$emit('fatherModal');

				}
			},
			//上传作品文件
			showmessagefromchild(data) {
			    let _this = this;



					if (data[0].status && data[0].status == 'uploading') {
						// console.log('没完成')
					}
					else{
						let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.') + 1)
						if (reImg.test(layout)) {
							data[0].url = util.thumbnail(data[0].url)
						} else if (reMusic.test(layout)) {
							data[0].url = _this.music;
						} else if (reText.test(layout)) {
							data[0].url = _this.text;
						} else if (reVideo.test(layout)) {
							data[0].url = _this.video;
						} else {
							data[0].url = _this.other;
						}

						_this.declare_upload_success = true;
						_this.declare_file_name = data[0].name
						_this.itemData = data?data[0]:''
					}



			    _this.myDciOrderList = data
				this.$forceUpdate()
			},
			_saveMyDciOrderUp() {
				let _this = this;
				let data = {
					orderSeqNo: _this.dataItem.orderSeqNo,
					url: _this.myDciOrderList.length>0? _this.myDciOrderList[0].attachmentUrl:'',
					registerId: _this.dataItem.registerId,
					registerAccountType: '',
					activityGiftId: '',
					discountFlag: _this.isActivity ? '1' : '0',
					subBizType:_this.myDciorderupPay
				};

				if (!data.url || data.url == '') {
					toast("请上传" + this.myDciorderupTitle + "附件")
					return false
				}
				else{
					if (!_this.isActivity && !_this.payWay) {
						toast('无可用次数')
						// $("#addcertButton").removeAttr("disabled");
						return;
					} else {
						if (!_this.isActivity && this.payWay.gift.activityGiftId) {
							Object.assign(data, {activityGiftId: this.payWay.gift.activityGiftId})
						}
					}
					_this.isDisabled = true;
					saveMyDciOrder(data).then( res => {
						this.resultJ(res);
					})
				}


			},
			resultJ(res) {
				console.log("提交后的返回结果：：：", res);
				if (res.code == 200) {
					toast(res.message)
					this.myDciOrderList.splice(this.myDciOrderList.indexOf(this.itemData), 1);
					this.parentHandleclick('success');
					// this.$router.push({path: '/myDciOrder'})
				} else if (res.code == 213) {
					toast("请实名认证后使用功能")
					this.$router.push('/authentication')
				} else if (res.code == 214) {
					toast("请购买会员后使用功能")
					if (userInfo.accountType == "person") {
						this.$router.push('/vipPersonal')
					} else {
						this.$router.push('/vipEnterprise')
					}
				} else if (res.code == 216) {
					this.isDisabled = false
				} else if (res.code == 215) {
					toast("VIP已到期，请续费")
					this.myczPayState = true;
					this.isDisabled = false
				} else {
					toast(res.message)
					this.isDisabled = false
				}
			},
			deleteList(item){
			    this.myDciOrderList.splice(this.myDciOrderList.indexOf(item), 1);
			}
        },
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 50%;
            top: 50%;
			transform: translate(-50%,-50%);
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
			.content{
				.item{
					display: flex;
					align-items: center;
					padding: 15px 30px;
					.lable{
						font-size: 14px;
					}
					.downText{
						margin-left: 30px;
						font-size: 12px;
						font-weight: 400;
						color: #f7b500;
						line-height: 17px;
						text-decoration: underline;
						cursor: pointer;
					}
				}
				.imglist{
					display:flex;
					justify-content:flex-start;
					padding: 15px 30px;
					flex-wrap: wrap;
					.show_Picture {
					    margin-right: 20px;
					    div {
					        width: 103px;
					        height: 17px;
					        font-size: 12px;
					        font-weight: 400;
					        color: rgba(102, 102, 102, 1);
					        line-height: 17px;
					        overflow: hidden;
					        text-overflow: ellipsis;
					        white-space: nowrap;
					        margin-top: 5px;
					    }
					    .showSc {
					        position: relative;
					        height: 70px;
					        width: 103px;
					        cursor: pointer;
					        &:hover {
					            width: 103px;
					            height: 70px;
					
					            .showDelete {
					                display: block;
					            }
					        }
					        .showDelete {
					            width: 103px;
					            height: 70px;
					            background: rgba(0, 0, 0, 0.3);
					            display: none;
					            position: absolute;
					            left: 0;
					            right: 0;
					            top: 0;
					            bottom: 0;
					            margin: auto;
					            text-align: center;
					            overflow: hidden;
					        }
					        .showshanchu {
					            width: 18px;
					            height: 18px;
					            margin-top: 26px;
					        }
					    }
					}
				}
				.tishi{
					padding: 15px 30px;
					text-align: left;
					.title{
						font-size: 14px;
						margin-bottom: 10px;
					}
					.text{
						font-size: 14px;
						line-height: 1.6;
					}
				}
				.row_item_1 {
					width: 100%;
					height: 80px;
					display: flex;
					justify-content: flex-start;
					align-items: flex-start;
				}

				.col_label {
					width: 100px;
					/*align-self: center;*/
					padding-top: 30px;
					p {
						width: 100px;
						text-align: right;
						font-size: 14px;
						font-weight: 400;
						color: rgba(102, 102, 102, 1);
						line-height: 20px;
					}
				}

				.col_value {
					display: flex;
					align-items: center;
				}

				.top20 {
					margin-top: 20px;
				}
				.upBtn{
					width: 120px;
					height: 33px;
					line-height: 33px;
					outline: none;
					border: 0;
					background: #fed800;
					border-radius: 2px;
					border: 1px solid #efefef;
					font-size: 14px;
					font-weight: 400;
					color: #333333;
					cursor: pointer;
					margin: 30px auto;
				}
			}
		}
    }

	.upload_progress_one {
		margin: 0 2px 8px 30px;
		width: 138px;
		height: 38px;
		border: 1px solid #F7B500;
		border-radius: 4px;
		font-size: 14px;
		text-align: center;
		line-height: 38px;
		color: #F7B500;
		position: relative;

		.upload_progress_one_shadow {
			position: absolute;
			left: 0;
			top: 0;
			height: 100%;
			background: rgba(255, 216, 0, 0.3);
			border-radius: 4px;
			transition: all .5s;
		}

	}

	.declare_upload_success_name{
		margin-left: 20px;
		max-width: 200px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
</style>